import * as React from "react";

export type Formatter = (value: any) => React.ReactNode;

export const identity = val => <>{val}</>;

/**
 * Create a formatter with a given set of options
 * */
export const createFormatSelect = (options: { value: string; label: string }[]) => val => (
  <>{options.find(opt => opt.value === val).label}</>
);

/**
 * Replace new lines with <br>
 * */
export const formatTextArea: Formatter = (val: string) => {
  return (
    <>
      {val.split("\n").reduce((acc, item) => {
        if (acc.length === 0) {
          return [<React.Fragment key={acc.length}>{item}</React.Fragment>];
        }
        return [
          ...acc,
          <br key={`br_${acc.length}`} />,
          <React.Fragment key={acc.length}>{item}</React.Fragment>,
        ];
      }, [])}
    </>
  );
};
